import React, {Component} from "react";
import './index.css'
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import Resource from "../../../Resource";
import PropTypes from 'prop-types'
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import Configuration from "../../../Server/Configuration";
import File from "../../../Components/Control/File";

class ModalDoctor extends Component {
    constructor(props) {
        super(props);

        props.refer.current = this;

        this.state = {
            title: {
                INSERT: 'افزودن پزشک',
                UPDATE: 'ویرایش پزشک',
                VIEW: 'اطلاعات پزشک'
            },
            hospitals: [{id: '', text: '...'}],
            fields: {},
            error: false,
            loadingSections: false
        };

        this.ref = {
            modal: React.createRef(),
            insert: React.createRef(),
            update: React.createRef(),
            close: React.createRef(),
            hospitalId: React.createRef(),
            sectionId: React.createRef(),
            firstName: React.createRef(),
            lastName: React.createRef(),
            image: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        hospitalId: x => Boolean(x && x[0].id) || 'بیمارستان انتخاب نشده است.',
        sectionId: x => Boolean(x && x[0].id) || 'بخش انتخاب نشده است.',
        firstName: x => Boolean(x) || 'نام وارد نشده است.',
        lastName: x => Boolean(x) || 'نام خانوادگی وارد نشده است.',
        image: x => Boolean(x) || 'امضا پزشک انتخاب نشده است.'
    };

    componentDidMount() {


        this.loadingSections();
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields ||
            state.hospitals !== nextState.hospitals ||
            state.loadingSections !== nextState.loadingSections ||
            state.loadingRoles !== nextState.loadingRoles ||
            state.roles !== nextState.roles;
    }

    render() {
        const {state} = this;
        const sections = [{id: '', text: '...'}];
        let readOnly = state.action === ModalAction.VIEW;

        if (state.fields?.hospitalId)
            sections.push(...state.fields?.hospitalId[0].sections);

        return <Modal ref={this.ref.modal}
                      name={'ModalDoctor'}
                      size={'medium'}
                      title={state.title[state.action]}
                      error={state.error}
                      loading={(state.loadingSections || state.loadingRoles) ? 'در حال دریافت اطلاعات' : false}>
            <ModalContent>
                <div className={'dis-f'}>
                    <div className={'fb-15 dis-f'}>
                        <Input ref={this.ref.firstName} value={state.fields?.firstName} className={'pad-4 fb-8'} label={'نام'} readOnly={readOnly} validation={this.validations.firstName} onChange={this.field.bind(this, 'firstName')}/>
                        <Input ref={this.ref.lastName} value={state.fields?.lastName} className={'pad-4 fb-12'} label={'نام خانوادگی'} readOnly={readOnly} validation={this.validations.lastName} onChange={this.field.bind(this, 'lastName')}/>
                        <Select ref={this.ref.hospitalId} value={state.fields?.hospitalId} options={state.hospitals} className={'pad-4 fb-10'} label={'نام بیمارستان'} readOnly={readOnly} validation={this.validations.hospitalId} onChange={this.field.bind(this, 'hospitalId')}/>
                        <Select ref={this.ref.sectionId} value={state.fields?.sectionId} options={sections} className={'pad-4 fb-10'} label={'نام بخش'} readOnly={readOnly} validation={this.validations.sectionId} onChange={this.field.bind(this, 'sectionId')}/>
                    </div>
                    <File className={'pad-4 fb-5'} label={'فایل امضا پزشک را انتخاب کنید.'} format={['image/*']} validation={this.validations.image} onChange={this.field.bind(this, 'image')}/>
                </div>
            </ModalContent>
            <ModalControls>
                {state.action === ModalAction.UPDATE && <Button className={'mar-4'} theme={'green'} icon={Resource.IMAGE.PACK.FILE.WHITE} onClick={this.view.bind(this)}>دریافت فایل</Button>}
                {state.action === ModalAction.INSERT && <Button refer={this.ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>افزودن پزشک</Button>}
                {state.action === ModalAction.UPDATE && <Button refer={this.ref.update} className={'mar-4'} theme={'yellow'} onClick={this.updateClickHandler.bind(this)}>ویرایش پزشک</Button>}
                <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
            </ModalControls>
        </Modal>;
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    field(key, value) {
        const fields = {...this.state.fields};

        fields[key] = value;
        if (key === 'hospitalId') {
            delete fields['sectionId'];
        }

        this.setState({fields});
    }

    insertClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.insert.current.loading();
            this.setState({error: null});

            Configuration.addDoctor({
                hospitalId: state.fields?.hospitalId[0]?.id,
                sectionId: state.fields?.sectionId[0]?.id,
                firstName: state.fields?.firstName,
                lastName: state.fields?.lastName,
                image: state.fields?.image?.[0]
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();

                ref.insert.current.loading(false);

                this.close(true);
            }).catch(message => {
                ref.insert.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    loadingSections() {
        if (this.state.hospitals.length <= 1) {
            this.setState({loadingSections: true});

            Configuration.sectionsList()
                .then(list => {
                    const hospitals = {};

                    for (let item of list) {
                        if (!hospitals[item.hospitalId]) {
                            hospitals[item.hospitalId] = {
                                id: item.hospitalId,
                                text: item.hospitalFullName,
                                sections: []
                            };
                        }

                        hospitals[item.hospitalId].sections.push({id: item.sectionId, text: item.sectionName});
                    }

                    this.setState({
                        hospitals: [{id: '', text: '...', sections: []},
                            ...Object.values(hospitals)],
                        loadingSections: false
                    });
                })
                .catch(message => {
                    new Notif({message, theme: 'error'}).show();
                    this.ref.modal.current.close();
                    this.setState({loadingSections: false});
                });
        }
    }

    open(data, action) {
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {},
                error: null
            });
        } else if ([ModalAction.VIEW, ModalAction.UPDATE].includes(action)) {
            // eslint-disable-next-line eqeqeq
            const sections = this.state?.hospitals?.find(item => item.id == data.hospitalId)?.sections || [];
            this.setState({
                data,
                action,
                fields: {
                    hospitalId: [{id: data.hospitalId, text: data.hospitalIdFullName, sections, forced: true}],
                    sectionId: [{id: data.sectionId, text: data.sectionStr, forced: true}],
                    firstName: data.docterFirstName,
                    lastName: data.docterLastName
                },
                error: null
            });
        }

        return this.ref.modal.current.open();
    }

    updateClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.update.current.loading();
            this.setState({error: null});
            console.log(state.data);

            Configuration.updateDoctor({
                doctorId: state.data?.docterId,
                hospitalId: state.fields?.hospitalId[0]?.id,
                sectionId: state.fields?.sectionId?.[0]?.id || null,
                firstName: state.fields?.firstName,
                lastName: state.fields?.lastName,
                image: state.fields?.image?.[0] || undefined
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();

                ref.update.current.loading(false);

                this.close(true);
            }).catch(message => {
                ref.update.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    view() {
        const {state} = this;

        window.open(window.ENV.MAIN_SERVER+state.data.docterSignatureAddress);
    }

    validate() {
        const validate = Tool.validate(
            this.ref.firstName,
            this.ref.lastName,
            this.ref.hospitalId,
            this.ref.sectionId);

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base
    };
};

export default connect(mapStateToProps)(ModalDoctor)